import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import NumberInput from '../../../../../../components/form/NumberInput'
import Select from '../../../../../../packages/kiti/components/form/Select'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'

const GoogleCalendarSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { handleChangeIn, form } = useFormState()

  return (
    <>
      <Text size="h2">:</Text>

      <EditableSentence
        label={form.payload?.integration?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <FormItem label={t('googleCalendar.eventTitle')} path={['payload', 'name']} />
        <Separator weight={4} />

        <FormItem label={t('googleCalendar.description')} path={['payload', 'description']} Input={Textarea} />

        <Separator weight={4} />

        <Grid gutter={0.2}>
          <Col width="50%">
            <FormItem label={t('googleCalendar.startsAt')} path={['payload', 'start']} />
          </Col>

          <Separator weight={2} />

          <Col width="50%">
            <FormItem
              label={t('googleCalendar.duration')}
              path={['payload', 'duration']}
              Input={Select}
              options={[
                { id: '15', name: t('googleCalendar.durationOptions.15') },
                { id: '30', name: t('googleCalendar.durationOptions.30') },
                { id: '60', name: t('googleCalendar.durationOptions.60') },
                { id: '90', name: t('googleCalendar.durationOptions.90') },
                { id: '120', name: t('googleCalendar.durationOptions.120') },
                { id: '150', name: t('googleCalendar.durationOptions.150') },
                { id: '180', name: t('googleCalendar.durationOptions.180') },
                { id: '210', name: t('googleCalendar.durationOptions.210') },
                { id: '240', name: t('googleCalendar.durationOptions.240') }
              ]}
              selectOnlyId
            />
          </Col>
        </Grid>

        <Separator weight={4} />

        <FormItem label={t('googleCalendar.emailReminder')} path={['payload', 'reminders']} Input={NumberInput} />

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default GoogleCalendarSentence
